(function () {
  var mobileQuery = window.matchMedia('(max-width: 48rem)');

  function setMenuState(header, isOpen) {
    var toggle = header.querySelector('[data-site-header-menu-toggle]');
    var menu = header.querySelector('[data-site-header-menu]');

    if (!toggle || !menu) return;

    toggle.setAttribute('aria-expanded', String(isOpen));
    header.classList.toggle('is-menu-open', isOpen);

    if (mobileQuery.matches) {
      menu.hidden = !isOpen;
    } else {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'false');
      header.classList.remove('is-menu-open');
    }
  }

  function closeOtherMenus(activeHeader) {
    document.querySelectorAll('.site-header.is-menu-open').forEach(function (header) {
      if (header !== activeHeader) {
        setMenuState(header, false);
      }
    });
  }

  function initHeader(header) {
    var toggle = header.querySelector('[data-site-header-menu-toggle]');
    var menu = header.querySelector('[data-site-header-menu]');

    if (!toggle || !menu || toggle.hasAttribute('data-site-header-menu-bound')) return;

    toggle.setAttribute('data-site-header-menu-bound', 'true');
    setMenuState(header, false);

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      closeOtherMenus(header);
      setMenuState(header, !isOpen);
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        setMenuState(header, false);
      }
    });
  }

  function init(root) {
    root.querySelectorAll('.site-header').forEach(initHeader);
  }

  document.addEventListener('click', function (event) {
    if (!mobileQuery.matches || event.target.closest('.site-header')) return;

    document.querySelectorAll('.site-header.is-menu-open').forEach(function (header) {
      setMenuState(header, false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.site-header.is-menu-open').forEach(function (header) {
      setMenuState(header, false);
      var toggle = header.querySelector('[data-site-header-menu-toggle]');
      if (toggle) toggle.focus();
    });
  });

  function syncMenus() {
    document.querySelectorAll('.site-header').forEach(function (header) {
      setMenuState(header, header.classList.contains('is-menu-open'));
    });
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', syncMenus);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(syncMenus);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
